<template>
    <div>
        <el-dialog title="查询学员" width="1300px" class="icon-dialog" :visible.sync="show" @open="open"
            :before-close="closeForm" append-to-body>
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="搜索：">
                    <el-input size="small" v-model="formInline.phone" placeholder="输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <!--列表-->
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column prop="user_id" label="ID" width="60">
                </el-table-column>
                <el-table-column prop="username" label="学员名" width="auto">
                </el-table-column>
                <el-table-column prop="phone" label="手机号" width="auto">
                </el-table-column>
                <el-table-column prop="card_pwd" label="卡密" width="auto">
                </el-table-column>
                <el-table-column prop="expire" label="卡密有效天数" width="120">
                    <template slot-scope="{row}">
                        <div v-if="row.expire == 0">永久</div>
                        <div v-else>{{ row.expire }}天</div>
                    </template>
                </el-table-column>
                <el-table-column prop="bindtime" label="卡密绑定时间" width="auto">
                </el-table-column>
                <el-table-column prop="pay_time" label="卡密到期时间" width="auto">
                </el-table-column>
                <el-table-column align="center" label="操作" min-width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="update(scope.row)"><i
                                class="el-icon-edit" />卡密修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-dialog>
        <el-dialog title="修改卡密时间" :visible.sync="setDialogStatus" width="500px">
            <el-row>
                <div style="display: flex; align-items: center;">
                    <div style="width: 100px;">卡密:</div>
                    <el-input type="number" v-model="setcardtime.number" :readonly="true"></el-input>
                </div>
                <div style="display: flex; align-items: center;margin-top: 20px;">
                    <div style="width: 100px;">有效天数:</div>
                    <el-input type="text" v-model="setcardtime.expire" autoComplete="off" clearable
                        placeholder="请设置卡密时间"></el-input>
                </div>
                <div class="dialog-footer">
                    <el-button size="small" :loading="loading" type="primary" @click="submit">
                        <span v-if="!loading">确 定</span>
                        <span v-else>提 交 中...</span>
                    </el-button>
                    <el-button size="small" @click="closeForm1">取 消</el-button>
                </div>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import { getUser, editCard } from '../../api/userMG';
import Pagination from '../../components/Pagination'
export default {
    name: 'Add',
    components: {
        Pagination
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'small'
        },
        userid: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            formInline: {
                trainer_user_id: '',
                phone: ''
            },
            setcardtime: {
                number: '',
                expire: ''
            },
            setDialogStatus: false,
            loading: false, //是显示加载
            listData: [],
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
        }
    },
    watch: {
        show(val) {
            if (val) {
                this.formInline.trainer_user_id = this.userid
                this.getdata()
            }
        }
    },
    methods: {
        open() {
        },
        // 搜索事件
        search() {
            this.getdata()
        },
        getdata() {
            getUser(this.formInline).then(res => {
                this.listData = res.user_info.data
                this.pageparm.total =res.user_info.total

            })
        },
        update(row) {
            console.log(row);
            this.setcardtime.number = row.card_pwd
            this.setcardtime.expire = row.expire
            this.setDialogStatus = true
            console.log(this.setcardtime, '______');

        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
        submit() {
            this.loading = true
            editCard(this.setcardtime).then(res => {
                console.log(this.userid, '+++++');
                this.$message({ message: '操作成功', type: 'success' })
                this.getdata()
                this.closeForm1()
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        closeForm1() {
            this.setDialogStatus = false
        },
        closeForm() {
            this.$emit('update:show', false)
        },
    }
}
</script>
<style scoped >
.dialog-footer {
    margin: 40px 0px 0px 280px;
}
</style>



// WEBPACK FOOTER //
// src/views/coach/user.vue